import React from 'react'
import { useNavigate } from 'react-router-dom'
import routes from '../../config/settings/routes'
import { Typography, useQuery, useQueryParam } from '@chilecompra/react-kit'
import { Link, Root, Row } from './SearchGoodsAndServicesHeader.styles'

/**
 * The SearchGoodsAndServicesHeader's container.
 */
const SearchGoodsAndServicesHeader = () => {
  const navigate = useNavigate()
  const query = useQuery()
  const quoteCode = useQueryParam('quote')

  const handleBack = () => {
    query.set('quote', quoteCode)
    navigate({ pathname: routes.quoteStepTwo, search: query.toString() }, { replace: true })
  }

  return (
    <Root>
      <Row container>
        <Row item>
          <Link onClick={handleBack}>Volver</Link>
        </Row>
      </Row>
      <Row container>
        <Row item>
          <Typography color="black1" fontSize="27px" lineHeight="31px" padding="31px 0 8px" variant="h2">
            Agregar Productos o Servicios
          </Typography>
          <Typography color="black1" fontSize="16px" lineHeight="20px" padding="0 0 37px" variant="body1">
            Selecciona los productos o servicios a cotizar
          </Typography>
        </Row>
      </Row>
    </Root>
  )
}

export default SearchGoodsAndServicesHeader
